export default __webpack_public_path__ + "static/Artboard-4-3a605abd15a9a2c80701ab05d25adef3.webp";